import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
      <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6 w-full max-w-sm shadow-2xl">
        <div className="flex items-center gap-4 mb-4 text-red-400">
          <div className="p-3 bg-red-400/10 rounded-full">
            <SafeIcon icon={FiIcons.FiAlertTriangle} className="text-xl" />
          </div>
          <h3 className="text-xl font-bold text-white">{title || 'Are you sure?'}</h3>
        </div>
        <p className="text-slate-400 mb-6 text-sm leading-relaxed">
          {message || 'This action cannot be undone. Please confirm if you want to proceed.'}
        </p>
        <div className="flex justify-end gap-3">
          <button 
            onClick={onClose}
            className="px-4 py-2 text-slate-400 hover:text-white font-bold transition-colors"
          >
            Cancel
          </button>
          <button 
            onClick={() => { onConfirm(); onClose(); }}
            className="px-6 py-2 bg-red-500 hover:bg-red-600 text-white rounded-xl font-bold transition-all"
          >
            Confirm Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;